import Vue from 'vue'
import Router from 'vue-router'
import NewIndex from '@/view/NewIndex/index.vue'
import Fruit from '@/view/Fruit/index.vue'
import Fashion from '@/view/Fashion/index.vue'
import Government from '@/view/Government/index.vue'
import Agriculture from '@/view/Agriculture/index.vue'
import Enterprise from '@/view/Enterprise/index.vue'
import Country from '@/view/Country/index.vue'
import Store from '@/view/Store/index.vue'
import Food from '@/view/Food/index.vue'
import Homestay from '@/view/Homestay/index.vue'
import About from '@/view/About/index.vue'
import Case from '@/view/Case/index.vue'
import Product from '@/view/Product/index.vue'
import Contact from '@/view/Contact/index.vue'
import DigitalSupply from '@/view/Solutions/DigitalSupply/index.vue'
import SmartAgri from '@/view/Solutions/SmartAgri/index.vue'
import AgriSupply from '@/view/Solutions/AgriSupply/index.vue'
import AgriService from '@/view/Solutions/AgriService/index.vue'
import ProductTrace from '@/view/Solutions/ProductTrace/index.vue'
import AIAgent from '@/view/Solutions/AIAgent/index.vue'
import DataTwin from '@/view/Solutions/DataTwin/index.vue'
import CustomDev from '@/view/Solutions/CustomDev/index.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Index',
      component: NewIndex,
      meta: { showFooter: true }
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: { showFooter: false }
    },

    {
      path: '/solution/digitalSupply',
      name: 'DigitalSupply',
      component: DigitalSupply,
      meta: { showFooter: true }
    },
    {
      path: '/solution/smartAgri',
      name: 'SmartAgri',
      component: SmartAgri,
      meta: { showFooter: true }
    },
    {
      path: '/solution/agriSupply',
      name: 'AgriSupply',
      component: AgriSupply,
      meta: { showFooter: true }
    },
    {
      path: '/solution/agriService',
      name: 'AgriService',
      component: AgriService,
      meta: { showFooter: true }
    },
    {
      path: '/solution/productTrace',
      name: 'ProductTrace',
      component: ProductTrace,
      meta: { showFooter: true }
    },
    {
      path: '/solution/aiAgent',
      name: 'AIAgent',
      component: AIAgent,
      meta: { showFooter: true }
    },
    {
      path: '/solution/dataTwin',
      name: 'DataTwin',
      component: DataTwin,
      meta: { showFooter: true }
    },
    {
      path: '/solution/customDev',
      name: 'CustomDev',
      component: CustomDev,
      meta: { showFooter: true }
    },

    {
      path: '/fruit',
      name: 'Fruit',
      component: Fruit,
      meta: { showFooter: true }
    },
    {
      path: '/fashion',
      name: 'Fashion',
      component: Fashion,
      meta: { showFooter: true }
    },
    {
      path: '/government',
      name: 'Government',
      component: Government,
      meta: { showFooter: true }
    },
    {
      path: '/agriculture',
      name: 'Agriculture',
      component: Agriculture,
      meta: { showFooter: true }
    },
    {
      path: '/enterprise',
      name: 'Enterprise',
      component: Enterprise,
      meta: { showFooter: true }
    },
    {
      path: '/country',
      name: 'Country',
      component: Country,
      meta: { showFooter: true }
    },
    {
      path: '/store',
      name: 'Store',
      component: Store,
      meta: { showFooter: true }
    },
    {
      path: '/food',
      name: 'Food',
      component: Food,
      meta: { showFooter: true }
    },
    {
      path: '/homestay',
      name: 'Homestay',
      component: Homestay,
      meta: { showFooter: true }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { showFooter: true }
    }, {
      path: '/case',
      name: 'Case',
      component: Case,
      meta: { showFooter: true }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { showFooter: true }
    }
  ],
  // 路由切换时的滚动行为：
  // - 浏览器前进/后退：恢复之前记录的滚动位置
  // - 带 #hash 的跳转：滚动到对应锚点元素
  // - 普通打开新页面：滚动到页面顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
